
const Title = () => {
    return(
        <div className="welcome">
            <h1> Welcome to my ToDo Application!</h1>
        </div>
    )
}

export default Title;
